import { useEffect, useState } from "react";
import "../FormacionDesarrollo/css/Training.css";
import { useParams } from "react-router-dom";
import TrainingState from "../../context/FormacionDesarollo/TrainingState";
import { Route } from "react-router";
import TrainingTable from "./TrainingTable";
import Kardex from "./modals/Kardex";

const Training = (props: any) => {
  const { children, value, index, ...other } = props;
  const params = useParams<any>();
  const [id, setId] = useState<string>("id");
  useEffect(() => {
    setId(params.id);
  }, [params]);

  return (
    <>
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && (
        <TrainingState>
          <Route
            component={(props: any) =>
              id === "id" ? (
                <TrainingTable {...props} />
              ) : (
                <TrainingTable {...props} />
              )
            }
          />
          <Kardex />
        </TrainingState>
      )}
    </div>
    </>
  );
};

export default Training;
